import React from "react";
import {
  InstrumentTypeSelectField,
  MaterialColorSelectField,
} from "@syos-music/instruments";

import { Grid } from "@mui/material";

export default function OptionsFields({ name }) {
  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <InstrumentTypeSelectField
          instrument="clarinet"
          name={`${name}.clarinetType`}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField name={`${name}.color`} allowPrivate />
      </Grid>
    </Grid>
  );
}
